<template>
      <div class="gouwu">
          <div class="gouwu_top">
                <p class="">通讯录</p>
                <img src="../../assets/images/licai/txl.png">
          </div>
            <div class="gouwu_sousuo">
                <img src="../../assets/images/licai/sousuo.png">
                <p class="">搜索</p>
            </div>
            <div class="gouwu_mid">
                <div class="gouwu_mid_list">
                    <img src="../../assets/images/licai/qunliao.png" alt="">
                    <p class="">新的朋友</p>
                </div>
                <div class="gouwu_mid_list">
                   <img src="../../assets/images/licai/qunliaos.png" alt="">
                    <p class="">群聊</p>
                </div>
            </div>
            <div class="gouwu_mid">
                <p class="gouwu_mid_tit">L</p>
                <div class="gouwu_mid_list">
                   <img src="../../assets/images/licai/qunliaos.png" alt="">
                    <p class="">FNVFJS</p>
                </div>
            </div>
      </div>
</template>
<script>
import Recommend from "@components/Recommend";
import {
  getCartList,
  postCartDel,
  changeCartNum,
  getCartCount,
} from "@api/store";
import { postCollectAll } from "@api/user";
import { mul, add } from "@utils/bc";
import cookie from "@utils/store/cookie";
import debounce from "lodash.debounce";

const CHECKED_IDS = "cart_checked";

export default {
  name: "ShoppingCart",
  components: {
    Recommend,
  },
  props: {},
  data: function () {
    return {
      cartList: { invalid: [], valid: [] },
      isAllSelect: false,
      cartCount: 0,
      countmoney: 0,
      goodsHidden: true,
      footerswitch: false,
      count: 0,
      checkedIds: [],
      loaded: false,
      index_num: 0,
    };
  },
  watch: {
    $route(n) {
      if (n.name === "ShoppingCart") {
        this.carnum();
        this.countMoney();
        this.getCartList();
        this.gainCount();
        this.goodsHidden = true;
        this.footerswitch = false;
      }
    },
  },
  mounted: function () {
    let that = this;
    that.carnum();
    that.countMoney();
    that.getCartList();
    that.gainCount();
  },
  methods: {
    getCartList: function () {
      let that = this;
      getCartList().then((res) => {
        that.cartList = res.data;
        let checkedIds = cookie.get(CHECKED_IDS) || [];
        if (!Array.isArray(checkedIds)) checkedIds = [];
        this.cartList.valid.forEach((cart) => {
          if (checkedIds.length) {
            if (checkedIds.indexOf(cart.id) !== -1) cart.checked = true;
            else cart.checked = false;
          } else {
            cart.checked = true;
            that.checkedIds.push(cart.id);
          }
        });
        if (checkedIds.length) {
          that.checkedIds = checkedIds;
        }
        that.isAllSelect =
          that.checkedIds.length === this.cartList.valid.length;
        that.carnum();
        that.countMoney();
        this.loaded = true;
      });
    },
    //删除商品；
    delgoods: function () {
      let that = this,
        id = [],
        valid = [],
        list = that.cartList.valid;
      list.forEach(function (val) {
        if (val.checked === true) {
          id.push(val.id);
        }
      });
      if (id.length === 0) {
        that.$dialog.toast({ mes: "请选择产品" });
        return;
      }
      postCartDel(id).then(function () {
        list.forEach(function (val, i) {
          if (val.checked === false || val.checked === undefined)
            valid.push(list[i]);
        });
        that.$set(that.cartList, "valid", valid);
        that.carnum();
        that.countMoney();
        that.gainCount();
      });
    },
    // //获取数量
    gainCount: function () {
      let that = this;

      getCartCount().then((res) => {
        that.count = res.data.count;
      });
    },
    //清除失效产品；
    delInvalidGoods: function () {
      let that = this,
        id = [],
        list = that.cartList.invalid;
      list.forEach(function (val) {
        id.push(val.id);
      });
      postCartDel(id).then(function () {
        list.splice(0, list.length);
        that.gainCount();
      });
    },
    //批量收藏;
    collectAll: function () {
      let that = this,
        data = { id: [], category: "" },
        list = that.cartList.valid;
      list.forEach(function (val) {
        if (val.checked === true) {
          data.id.push(val.product_id);
          data.category = val.type;
        }
      });
      if (data.id.length === 0) {
        that.$dialog.toast({ mes: "请选择产品" });
        return;
      }
      postCollectAll(data).then(function () {
        that.$dialog.toast({ mes: "收藏成功!" });
      });
    },
    //立即下单；
    placeOrder: function () {
      let that = this,
        list = that.cartList.valid,
        id = [];
      list.forEach(function (val) {
        if (val.checked === true) {
          id.push(val.id);
        }
      });
      if (id.length === 0) {
        that.$dialog.toast({ mes: "请选择产品" });
        return;
      }
      this.$router.push({ path: "/order/submit/" + id });
    },
    manage: function () {
      let that = this;
      that.footerswitch = !that.footerswitch;
    },
    goodsOpen: function () {
      let that = this;
      that.goodsHidden = !that.goodsHidden;
    },
    //加
    plus: function (index) {
      let that = this;
      let list = that.cartList.valid[index];
      list.cart_num++;
      if (list.attrInfo) {
        if (list.cart_num >= list.attrInfo.stock) {
          that.$set(list, "cart_num", list.attrInfo.stock);
        }
      } else {
        if (list.cart_num >= list.stock) {
          that.$set(list, "cart_num", list.stock);
        }
      }
      that.carnum();
      that.countMoney();
      that.syncCartNum(list);
    },
    specifiName(index) {
      let list = this.cartList.valid[index];
      this.index_num = index;
      this.carnum();
      this.countMoney();
      this.syncCartNum(list);
    },
    blurName(index) {
      let list = this.cartList.valid[index];
      if (list.cart_num < 1) {
        this.$set(list, "cart_num", 1);
      }
      this.carnum();
      this.countMoney();
      this.syncCartNum(list);
    },
    //减
    reduce: function (index) {
      let that = this;
      let list = that.cartList.valid[index];
      list.cart_num--;
      if (list.cart_num < 1) {
        that.$set(list, "cart_num", 1);
      }
      that.carnum();
      that.countMoney();
      that.syncCartNum(list);
    },
    syncCartNum(cart) {
      if (!cart.sync)
        cart.sync = debounce(() => {
          changeCartNum(cart.id, Math.max(cart.cart_num, 1) || 1);
        }, 500);

      cart.sync();
    },
    //单选
    switchSelect: function (index) {
      let that = this,
        cart = that.cartList.valid[index],
        i = this.checkedIds.indexOf(cart.id);
      cart.checked = !cart.checked;

      if (i !== -1) this.checkedIds.splice(i, 1);
      if (cart.checked) {
        this.checkedIds.push(cart.id);
      }
      let len = that.cartList.valid.length;
      let selectnum = [];
      for (let i = 0; i < len; i++) {
        if (that.cartList.valid[i].checked === true) {
          selectnum.push(true);
        }
      }
      that.isAllSelect = selectnum.length === len;
      that.$set(that, "cartList", that.cartList);
      that.$set(that, "isAllSelect", that.isAllSelect);
      cookie.set(CHECKED_IDS, that.checkedIds);
      that.carnum();
      that.countMoney();
    },
    //全选
    allChecked: function () {
      let that = this;
      let selectAllStatus = that.isAllSelect;
      selectAllStatus = !selectAllStatus;
      let checkedIds = [];
      // for (let i = 0; i < array.length; i++) {
      //   array[i].checked = selectAllStatus;
      //   checked.push()
      // }
      that.cartList.valid.forEach((cart) => {
        cart.checked = selectAllStatus;
        if (selectAllStatus) checkedIds.push(cart.id);
      });
      that.$set(that, "cartList", that.cartList);
      that.$set(that, "isAllSelect", selectAllStatus);
      this.checkedIds = checkedIds;
      cookie.set(CHECKED_IDS, checkedIds);
      that.carnum();
      that.countMoney();
    },
    //数量
    carnum: function () {
      let that = this;
      var carnum = 0;
      var array = that.cartList.valid;
      for (let i = 0; i < array.length; i++) {
        if (array[i].checked === true) {
          if (array[i].cart_num) carnum += parseInt(array[i].cart_num);
        }
      }
      that.$set(that, "cartCount", carnum);
    },
    //总共价钱；
    countMoney: function () {
      let that = this;
      let carmoney = 0;
      let array = that.cartList.valid;
      for (let i = 0; i < array.length; i++) {
        if (array[i].checked === true) {
          carmoney = add(carmoney, mul(array[i].cart_num, array[i].truePrice));
        }
      }
      that.countmoney = carmoney;
    },
  },
};
</script>
<style scoped>
.gouwu_top{
  width: 100%;
  height: 40px;
  font-size: 18px;
  line-height: 40px;
  text-align: center;
  position: relative;
}
.gouwu_mid_tit{
  width: 100%;
  background-color: #f5f5f5;
  color: #000;
  padding-left:10px;
  height: 40px;
  line-height: 40px;
}
.gouwu_mid{
  background-color: #ffffff;
  padding: 10px 15px;
}
.gouwu_mid_list{
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.gouwu_mid_list img{
  width: 40px;
  height: 40px;
}
.gouwu_mid_list p{
  margin-left: 15px;
}
.gouwu_top img{
  position: absolute;
  top: 5px;
  right: 4%;
  width: 25px;
  height: 25px;
}
.gouwu_sousuo{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #666;
  width: 92%;
  margin: 0 auto;
  height: 40px;
  border-radius: 24px;
  color: #fff;
  margin-top: 15px!important;
}
.gouwu_sousuo img{
  width: 25px;
  height: 25px;
}
.ipt_num {
  width: 100%;
  display: block;
  line-height: 0.44rem;
  text-align: center;
}
</style>
